import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  icon: {
    cursor: 'pointer',
    marginLeft: `${theme.spacing(1)} !important`,
    marginTop: `${theme.spacing(-1)} !important`,
    color: 'rgb(244, 67, 54)',
  },
  chip: {
    cursor: 'pointer',
    marginLeft: `${theme.spacing(1)} !important`,
    marginTop: `${theme.spacing(-1)} !important`,
    height: '24px !important',
    backgroundColor: 'rgb(244, 67, 54) !important',
  },
  avatar: {
    width: '24px !important',
    padding: '0 !important',
    marginRight: `${theme.spacing(-2)} !important`,
    marginLeft: `${theme.spacing(-1)} !important`,
    height: '24px !important',
    backgroundColor: 'rgb(244, 67, 54) !important',
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
}))
